import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";

const ContactUs = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_85vncqh",
                "template_sh7wgvk",
                "#myForm",
                "dphUMCkFYP0BZruxu"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>

            <section className="page_breadcrumb" style={{ background: 'url(assets/img/breadcrumb_bg.webp)' }}>
                <div className="breadcrumb_overlay">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="breadcrumb_text">
                                    <h1>Contact us</h1>
                                    <ul className="d-flex flex-wrap">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/">contact us</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="contact_us pt_120 xs_pt_100" style={{ marginTop: "-90px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="contact_info">
                                <div className="icon">
                                    <img src="assets/images/location_icon_blue.svg" alt="Location" className="img-fluid" />
                                </div>
                                <div className="text">
                                    <h2>Office Address</h2>
                                    <p><a style={{ color: "black", textAlign: "center" }} href='https://share.google/Y2joXxIxcJNCmerGc'>Birla Road Badhiya Near Durga Mandir Sundar Tower 2nd Floor Satna MP
                                        PIN Code 485001</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="contact_info">
                                <div className="icon">
                                    <img src="assets/images/mail_icon_black.svg" alt="Mail" className="img-fluid" />
                                </div>
                                <div className="text">
                                    <h2>Email Address</h2>
                                    <a href="mailto:info@sewaxservices.com"> info@sewaxservices.com</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6 wow fadeInRight" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                            <div className="contact_info">
                                <div className="icon">
                                    <img src="assets/images/call_icon_black.svg" alt="Location" className="img-fluid" />
                                </div>
                                <div className="text">
                                    <h2>Need Any Cleaning Help</h2>
                                    <a href="callto:+91 9174282618"> +91 9174282618</a>
                                    <a href="callto:+91 8889997714"> +91 8889997714</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form className="contact_form booking_info_form wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Name</label>
                                <input type="text" placeholder="name" />
                            </div>
                            <div className="col-md-6">
                                <label>email</label>
                                <input type="email" placeholder="email" />
                            </div>
                            <div className="col-md-6">
                                <label>Phone</label>
                                <input type="text" placeholder="Enter phone number" />
                            </div>
                            <div className="col-md-6">
                                <label>Service</label>
                                <input type="text" placeholder="Service" />
                            </div>

                            <div className="col-md-12">
                                <label>Full Address</label>
                                <textarea rows={6} placeholder="Your address" defaultValue={""} />
                                <Link to="/">
                                    <button type="submit" className="common_btn">Book An Appointment</button>
                                </Link>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="contact_map mt_30 xs_mt_0">
                    <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=400&hl=en&q=Sewax Services Private Limited Satna&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google maps embed</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>
                </div>
            </section>






        </>
    )
}

export default ContactUs